import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { BlogCard } from '../../../../../shared/components/blog-card/blog-card';
import { IBlogPostMeta } from '../../../../../shared/interfaces/blog-post.interface';

const MAX_POST_INDEX = 7;


@Component({
  selector: 'app-post-carousel-mobile',
  imports: [CommonModule, BlogCard],
  templateUrl: './post-carousel-mobile.html',
  styleUrl: './post-carousel-mobile.scss',
})
export class PostCarouselMobile {

  @Input()
  public postsRaw: IBlogPostMeta[] = [];

  protected showPost = signal(true);

  private activeIndex = 0;
  private carouselTimeout = 4000;
  private timer: any;

  constructor() { }

  ngOnInit() {
    this.startCarouselAutoplay();
  }

  ngOnDestroy() {
    this.clearCarouselTimer();
  }

  private startCarouselAutoplay() {
    this.clearCarouselTimer();
    this.timer = setTimeout(() => {
      this.showPost.update((show) => !show);
      this.nextStep();
      this.startCarouselAutoplay();
    }, this.carouselTimeout);
  }

  private nextStep() {
    setTimeout(() => {
      this.activeIndex = this.activeIndex === this.limit ? 0 : this.activeIndex + 1;
      this.showPost.update((show) => !show);
    }, 50);
  }

  private clearCarouselTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  get limit(): number {
    return Math.min(this.postsRaw.length - 1, MAX_POST_INDEX);
  }

  get activePost(): IBlogPostMeta {
    return this.postsRaw[this.activeIndex] ?? this.postsRaw[0];
  }
}
